export function BtnWebPalermo({ label = 'Web Sweet Palermo', className = '' }) {
    return (
        <a
            href="http://www.sweetpalermo.com/"
            target="_blank"
            title="Web Sweet Palermo"
            rel="noreferrer"
            className={`inline-block px-8 text-white border border-white rounded-full border-[#CE3235] font-bold text-2xl py-4 inline-block ${className}`}>
            {label}
        </a>
    )
}
